export const EMAIL_CAPTURE_CAMPAIGN = 'email_capture_modal';

export const EMAIL_CAPTURE_COOKIE = 'no_email_capture_modal';

export const EMAIL_CAPTURE_OFFER_CODE = 'Color_FSOrder';

export const EMAIL_SOURCE = 'popup_email_capture';

export const PHONE_CAPTURE_EXPERIMENT = 'Phone Number in Email Capture Test';

export const PHONE_CAPTURE_COOKIE = 'no_phone_capture_modal';

export const EXPERIMENT_CONFIGS = {};

export const EMAIL_CAPTURE_MODAL_DELAY = {
  delay: 3000
};

export const EMAIL_CAPTURE_DEFAULT_CONFIG = {
  title: {
    default: 'GET FREE SHIPPING',
    success: 'CONGRATS, FREE SHIPPING APPLIED',
  },
  description: {
    default: `Share your email to get FREE SHIPPING on your first order, plus the inside scoop on exclusive promotions, hair tips, and events near you.`,
    success: 'Free shipping will be automatically applied during checkout on your first purchase.',
  },
  conditions: 'Free standard shipping on first order, valid for new customers only. Unsubscribe anytime.',
  code: 'Color_FSOrder',
  email_source: 'popup_email_capture',
};

export const EMAIL_CAPTURE_PATH_CONFIGS = [
  {
    config: {
      title: {
        default: 'GET 10% OFF YOUR FIRST SERVICE',
        success: 'CONGRATS, 10% OFF APPLIED',
      },
      description: {
        default: "Share your email & we'll treat you to 10% OFF on your first service at our hair color bars.",
        success: '10% OFF will be automatically applied.',
      },
      conditions: '10% off on your first hair color bar service. Valid for new customers only. Unsubscribe anytime.',
      code: 'BOOKING10',
      email_source: 'HCB_email_capture',
    },
    paths: ['/colorbar'],
  },
];

export const EMAIL_CAPTURE_KEY_CONFIGS = {
  phoneCapture: {
    title: {
      default: 'UPGRADE TO 10% OFF',
      success: 'FREE SHIPPING AND 10% OFF APPLIED',
    },
    description: {
      default: `Share your phone number to get 10% off, plus FREE shipping!`,
      success: 'Continue shopping or use the link in your text message at a later time to redeem your offer. Valid for your first purchase.',
    },
    conditions: 'By submitting this form, you agree to receive automated promotional marketing text messages from Madison Reed via the phone number provided. Consent is not a condition of any purchase. Reply STOP to cancel. Standard message and data rates may apply.',
    code: 'SMSOFFER',
    phone_source: 'popup_phone_capture',
  }
};

export const EMAIL_CAPTURE_ALLOWED_PATHS = [];

export const EMAIL_CAPTURE_BANNED_PATHS = [
  '/account',
  '/careers',
  '/cart',
  '/checkout',
  '/color-advisor',
  '/color-advisor-ulta',
  '/color-crew',
  '/compare-shades',
  '/confirmation',
  '/email',
  '/shop/hair-color',
  '/support',
  '/term',
  '/signIn',
  '/signin',
  '/booking',
  '/refer',
  '/share',
  '/tv',
  '/coloristcooperative',
  '/coloristaffiliates',
  '/coloristcooperative-raf',
  '/coloristcooperative-terms-and-conditions',
  '/quiz-on-q',
  '/color-consultation',
];

export const EMAIL_CAPTURE_RULES = {
  isFirstTimeVisitor: true,
  hasCapturedEmail: false,
  hasEmail: false,
  hasDismissedEmailModal: false,
  hasPurchaseHistory: false,
};

export const PHONE_CAPTURE_RULES = {
  isFirstTimeVisitor: true,
  hasCapturedEmail: true,
  hasEmail: true,
  hasDismissedEmailModal: true,
  hasDismissedPhoneModal: false,
  hasPurchaseHistory: false,
};